import { useClouds, useCloud } from '../cloudy/use-cloud';
const WHITE_CLOUD_COLORS = ['#fff'];
export const usePartlyCloud = useCloud;
export const usePartlyClouds = ({ count = 10, colors = WHITE_CLOUD_COLORS } = {
    count: 10,
    colors: WHITE_CLOUD_COLORS,
}) => {
    return useClouds({
        count,
        colors,
    });
};
